import React from 'react';
import {Department} from 'acscp/api/models/customTypes/department';
import { FormattedMessage } from 'react-intl';

interface QuoteDetailsHeaderProps { departmentKey: Department; }

const QuoteDetailsHeader: React.FC<QuoteDetailsHeaderProps> = ({
    departmentKey,
}) => {
    switch (departmentKey) {
        case Department.ACMI:
            return (
                <FormattedMessage
                    id={'components.quotes.quote.offerDetails'}
                    defaultMessage={'Offer Details'}
                />
            );
        case Department.COMMJ:
            return (
                <FormattedMessage
                    id={'components.quotes.quote.optionDetails'}
                    defaultMessage={'Option Details'}
                />
            );
        case Department.Cargo:
        case Department.PJETS:
            return (
                <FormattedMessage
                    id={'components.quotes.quote.quoteDetails'}
                    defaultMessage={'Quote Details'}
                />
            );
    }
};

export {QuoteDetailsHeader};
